const isCompositeImage = (element) => !!element && !!element.closest('ws-composite-item');

export default isCompositeImage;
